import { __awaiter } from "tslib";
import { ItemsEntity, Uploader } from '@citrite/sf-api';
import { RID } from '@sharefiledev/sfplugin-resource-id';
import { ProjectsNetworkError } from '../ProjectsNetworkError';
import { ResourceEntityType } from '../types';
export function uploadFiles(dataProvider, requestingResourceId, files, options) {
    return __awaiter(this, void 0, void 0, function* () {
        const requestingRid = RID.parse(requestingResourceId);
        const projectRid = requestingRid.findEntityType(ResourceEntityType.project);
        if (!projectRid) {
            throw new Error(`No project resource found for: ${requestingResourceId}`);
        }
        const zoneServiceValue = yield dataProvider.getProjectZoneServices(projectRid.entityId);
        const itemUploads = files.map(file => ({
            file,
            itemUpload: Uploader.createItemUpload(file, item => ({
                execute: () => dataProvider
                    .uploadFile(projectRid.entityId, requestingResourceId, Object.assign(Object.assign({}, item.uploadRequestParams), { Overwrite: options === null || options === void 0 ? void 0 : options.overwrite }))
                    .catch(error => {
                    var _a;
                    if (error instanceof ProjectsNetworkError) {
                        if (error.status === 409) {
                            (_a = options === null || options === void 0 ? void 0 : options.onConflict) === null || _a === void 0 ? void 0 : _a.call(options, item, file);
                        }
                        throw { status: error.status }; // prevents sf-api from retrying the upload for certain status codes
                    }
                    throw error;
                }),
            }), undefined, zoneServiceValue),
        }));
        itemUploads.forEach(u => {
            const emitter = Uploader.addItemsToQueue(u.itemUpload);
            listenToUploaderEvents(dataProvider, requestingRid, emitter, options);
        });
        return itemUploads;
    });
}
function listenToUploaderEvents(dataProvider, requestingRid, emitter, options) {
    if (options === null || options === void 0 ? void 0 : options.onProgress) {
        emitter.on('progress', e => {
            var _a;
            let percent = 0;
            try {
                percent = parseInt(e.percent.replace('%', ''), 10);
            }
            catch (_b) { }
            (_a = options.onProgress) === null || _a === void 0 ? void 0 : _a.call(options, {
                currentUploadId: e.currentFile.uploadId,
                uploadBatchId: '',
                percent,
            });
        });
    }
    if (options === null || options === void 0 ? void 0 : options.onSuccess) {
        emitter.on('success', (uploads) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const projectRid = requestingRid.findEntityType(ResourceEntityType.project);
            const successfulFiles = [];
            const erroredFiles = [];
            for (const itemUpload of uploads) {
                const itemUrl = ItemsEntity.get(itemUpload.shareFileId).getUrl();
                const item = yield ItemsEntity.get(itemUrl).execute();
                const projectFile = yield dataProvider
                    .uploadFileComplete(projectRid.entityId, (_a = options.resourceId) !== null && _a !== void 0 ? _a : requestingRid.toString(), {
                    UploadedFileItems: [{ Filename: item.Name, StreamId: item.StreamID }],
                })
                    .catch(() => undefined);
                if (projectFile) {
                    const resourceId = requestingRid
                        .createChild(ResourceEntityType.file, projectFile.fileId)
                        .createChild(ResourceEntityType.fileStream, projectFile.shareFileStreamId)
                        .toString();
                    successfulFiles.push({
                        resourceId,
                        itemUpload,
                        metadata: projectFile,
                    });
                }
                else {
                    erroredFiles.push(itemUpload);
                }
            }
            if (erroredFiles.length) {
                (_b = options.onError) === null || _b === void 0 ? void 0 : _b.call(options, erroredFiles);
            }
            (_c = options.onSuccess) === null || _c === void 0 ? void 0 : _c.call(options, successfulFiles);
        }));
    }
    if (options === null || options === void 0 ? void 0 : options.onError) {
        emitter.on('error', items => {
            var _a;
            (_a = options.onError) === null || _a === void 0 ? void 0 : _a.call(options, items);
        });
    }
}
//# sourceMappingURL=uploadFiles.js.map